import { render, staticRenderFns } from "./Receita.vue?vue&type=template&id=3e3f034c&scoped=true"
import script from "./Receita.vue?vue&type=script&lang=js"
export * from "./Receita.vue?vue&type=script&lang=js"
import style0 from "./Receita.vue?vue&type=style&index=0&id=3e3f034c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f034c",
  null
  
)

export default component.exports